module.exports = __webpack_public_path__ + "static/media/loading.b77d05c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.svg
// module id = 691
// module chunks = 4